module.exports = __webpack_public_path__ + "static/media/simplepay-logos.6da637af.png";